<template>
  <cognitive-block type="section" class="cc-login">
    <LogoSidePanel class="cc-login__decoration" />
    <LoginPanel class="cc-login__form" />
  </cognitive-block>
</template>

<script>
// Libs
import { defineAsyncComponent } from 'vue'
export default {
  name: 'PageLogin',
  components: {
    LogoSidePanel: defineAsyncComponent(() => import('@/components/common/LogoSidePanel.vue')),
    LoginPanel: defineAsyncComponent(() => import('@/components/login/LoginPanel.vue')),
  },
}
</script>

<style lang="scss">
// Custom vars
$login-stage-h: calc(100vh - 3.5rem);
$login-stage-tablet-h: calc(100vh - 5.25rem);
.cc-login {
  display: flex;
  align-items: stretch;
  align-content: center;
  min-height: $login-stage-h;
  justify-content: center;

  @at-root .cc-ui-layout--login & {
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {
      min-height: $login-stage-tablet-h;
    }
  }

  @media #{$mq-md} {
    min-height: $login-stage-h;
  }

  &__decoration {
    display: none;

    @media #{$mq-md} {
      display: block;
      width: 50%;
    }

    @media #{$mq-lg} {
      width: 60%;
    }
  }

  &__form {
    width: 90%;
    margin-left: auto;

    @media #{$mq-md} {
      width: 50%;
    }

    @media #{$mq-lg} {
      width: 40%;
      min-width: 320px;
      max-width: 40%;
    }
  }
}
</style>
